module.exports = __webpack_public_path__ + "assets/img/82@3x.7b21c8f3.png";